import { styled } from "@mui/system";
import { Stepper, Card, Box } from "@mui/material";

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  "& .MuiStepLabel-root .Mui-completed": {
    color: "#ff9800", // orange color for completed steps
  },
  "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
    color: theme.palette.text.secondary,
  },
  "& .MuiStepLabel-root .Mui-active": {
    color: "#ff6f00", // orange color for active step
  },
  "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
    color: theme.palette.text.primary,
  },
  "& .MuiStepConnector-line": {
    borderColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
  },
}));

export const FormCard = styled(Card)(({ theme }) => ({
  maxWidth: 800,
  margin: "0 auto",
  padding: theme.spacing(4),
  boxShadow: theme.shadows[3],
}));

export const StepContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 0),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginTop: theme.spacing(3),
  paddingTop: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.divider}`,
}));
